import Homepage from '@@views/Homepage'

export default Homepage
